/*
 * Clears a search field — the header's and the one on /search alike.
 *
 * The theme already has this behavior in search.js, but it only ever runs when
 * predictive search is on: PredictiveSearch's constructor reaches straight for
 * a button[type="reset"] (search.js:6), and snippets/predictive-search.liquid
 * does not render one while settings.predictive_search_enabled is off, so the
 * constructor throws and the element never upgrades.
 *
 * Every clear control this theme adds is therefore type="button" — that keeps
 * search.js's selector missing them, so the element stays exactly as inert as
 * it is today and no predictive fetches start firing on keystrokes. If
 * predictive search is switched on later, the snippet renders its own
 * type="reset" CLEAR and search.js takes that one over; the search page's
 * close glyph keeps being handled here.
 *
 * Delegated from the document so it survives a section being re-rendered by
 * the theme editor.
 */
document.addEventListener('click', (event) => {
  const button = event.target.closest('.pako-search-clear');
  if (!button) return;

  const input = button
    .closest('.template-search__search, .header__search')
    ?.querySelector('input[type="search"]');
  if (!input) return;

  event.preventDefault();
  input.value = '';
  input.focus();
});
